import {
  ListProductHttpResponseDto, ProductHttpCostDto
} from '@features/product/infrastructure/http/list-product/list-product.http.response.dto';
import {
  ListProductResponseDto, ProductCostDto
} from '@features/product/application/use_cases/list-product/dto/list-product.response.dto';
import {ListProductPayloadDto} from '@features/product/application/use_cases/list-product/dto/list-product.payload.dto';
import {
  ListProductHttpPayloadDto
} from '@features/product/infrastructure/http/list-product/list-product.http.payload.dto';

export class ListProductHttpMapper {

  static toResponse(
    data: ListProductHttpResponseDto,
  ): ListProductResponseDto {
    return {
      meta: data.meta,
      data: data.data.map(item => ({
        id: item.id,
        agreement_id: item.agreement_id.toString(),
        name: item.name,
        description: item.description,
        type: item.type,
        court_date: item.court_date ? item.court_date.toString() : null,
        amortize_additional_costs: item.amortize_additional_costs == 1,
        min_amount: Number(item.min_amount),
        max_amount: Number(item.max_amount),
        step_amount: Number(item.step_amount),
        min_term: item.min_term,
        max_term: item.max_term,
        step_term: item.step_term,
        step_installment: item.step_installment,
        term_type: Number(item.term_type) as 1 | 2 | 3,
        rate_amount: Number(item.rate_amount),
        bail_amount: Number(item.bail_amount),
        bail_type: Number(item.bail_type),
        platform_cost: Number(item.platform_cost),
        platform_discount: Number(item.platform_discount),
        late_interest_ea: item.late_interest_ea,
        default: item.default == 1,
        hidden: item.hidden == 1,
        tyc_url: item.tyc_url,
        vat_value: item.vat_value,
        not_validate: item.not_validate == 1,
        document_validate: item.document_validate == 1,
        biometric_2d_validate: item.biometric_2d_validate == 1,
        biometric_3d_validate: item.biometric_3d_validate == 1,
        validation_cost: item.validation_cost,
        requirement_fields: item.requirement_fields,
        is_multicredit: item.is_multicredit == 1,
        is_rechargeable: item.is_rechargeable == 1,
        is_withdrawable: item.is_withdrawable == 1,
        is_manual_disbursement: item.is_manual_disbursement == 1,
        amortize_bail: false,
        credit_study: item.credit_study == 1,
        credit_study_value: item.credit_study_value,
        signature_template_id: item.signature_template_id,
        scoring_id: item.scoring_id,
        other_costs: item.other_costs.map(this.mapCost),
        discounts: item.discounts.map(this.mapCost),
        insurance: item.insurance.map(this.mapCost),
        taxes_cost: item.taxes_cost.map(this.mapCost),
        untaxed_cost: item.untaxed_cost.map(this.mapCost),
      })),
    };
  }

  static toInfra(
    data: ListProductPayloadDto,
  ): ListProductHttpPayloadDto {
    const {page, limit, ...rest} = data;
    const filters: Record<string, string> = {};
    for (const [key, value] of Object.entries(rest)) {
      if (value !== undefined) {
        filters[key] = String(value);
      }
    }
    return {page, limit, ...filters};
  }

  private static mapCost(item: ProductHttpCostDto): ProductCostDto {
    return {
      id: item.id.toString(),
      product_id: item.product_id,
      type: Number(item.type),
      value: Number(item.value),
      description: item.description,
      is_taxable: item.is_taxable,
    };
  }

}
